export default __webpack_public_path__ + "static/media/flexjobs.f0dc23c5.svg";